export enum MeliEvents {
    MELI_INTEGRATION_OPTIONS = "meli_integration_options",
    MELI_INTEGRATION = "meli_integration"
}